export default intNum => {
  if (!intNum) {
    return '0';
  }
  return intNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
